/* eslint-disable import/prefer-default-export */

export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const DELETE_CURRENT_USER = "DELETE_CURRENT_USER";
